import styled from 'styled-components';
import { AppStyledProps } from '@/components/types';
import { Props } from './types';

type T = Props & AppStyledProps;

export const ListStyled = styled.div<T>`
  max-height: 80vh;
  overflow-y: auto;
  font-size: 1em;
  ${({ isHorizontalMobileView }) => isHorizontalMobileView && 'height: 100px; overflow-y: scroll;'}

  .chapter {
    display: block;
    font-size: ${({ isHorizontalMobileView }) => (isHorizontalMobileView ? '0.8em' : '1em')};
    width: 100%;
    color: #fff;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    padding: 0.5em 1.25em;
    overflow-wrap: anywhere;

    &:hover {
      background-color: #2055ff;
      ${({ buttonColor }) => buttonColor && `background-color: ${buttonColor};`}
    }

    ${({ color }) => color && `color: ${color};`}
  }

  ${({ theme }) =>
    theme.device.mobile &&
    `
  `}
`;
